import React, { useMemo, useState } from 'react';

interface DashboardEmailFilterProps {
  ariaLabel: string;
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

export const DashboardEmailFilter: React.FC<DashboardEmailFilterProps> = ({
  ariaLabel,
  options,
  selected,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const normalizedOptions = useMemo(
    () => [...new Set([...selected, ...options].filter(Boolean))].sort(),
    [options, selected]
  );

  const selectedSet = useMemo(() => new Set(selected), [selected]);
  const buttonText =
    selected.length === 0
      ? 'All users'
      : selected.length === 1
        ? selected[0]
        : `${selected.length} users`;

  const toggleOption = (option: string) => {
    const next = new Set(selectedSet);
    if (next.has(option)) {
      next.delete(option);
    } else {
      next.add(option);
    }
    onChange([...next].sort());
  };

  return (
    <div className="dg-email-filter">
      <button
        type="button"
        className="dg-email-filter-button"
        aria-label={ariaLabel}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        <span>Updated by</span>
        <strong>{buttonText}</strong>
      </button>
      {isOpen ? (
        <div className="dg-email-filter-menu" role="menu">
          <button type="button" className="dg-email-filter-action" onClick={() => onChange([])}>
            All users
          </button>
          {normalizedOptions.length > 0 ? (
            normalizedOptions.map((option) => (
              <label key={option} className="dg-email-filter-option">
                <input
                  type="checkbox"
                  checked={selectedSet.has(option)}
                  onChange={() => toggleOption(option)}
                />
                <span title={option}>{option}</span>
              </label>
            ))
          ) : (
            <div className="dg-email-filter-empty">No users</div>
          )}
        </div>
      ) : null}
    </div>
  );
};
